module.exports = __webpack_public_path__ + "1fdcd4dfb35fdf29c9fd1406038863b8.png";